/**
 * FotMob-style referee card icon. Small upright rounded rectangle with a
 * subtle gradient + drop shadow so it reads like an actual playing card on
 * the table.
 *
 * <FmCard type="yellow" />
 * <FmCard type="red" size="lg" />
 * <FmCard type="yellow" count={2} />          // overlapping stack
 * <FmCard type="yellow-red" />                // both cards staggered
 */
export default function FmCard({ type = 'yellow', size = 'md', count = 1, className = '' }) {
  if (type === 'yellow-red') {
    return (
      <span className={`fmcard-stack ${className}`}>
        <FmCard type="yellow" size={size} />
        <FmCard type="red" size={size} />
      </span>
    );
  }

  if (count > 1) {
    return (
      <span className={`fmcard-stack ${className}`}>
        {Array.from({ length: count }).map((_, i) => (
          <FmCard key={i} type={type} size={size} />
        ))}
      </span>
    );
  }

  return <span className={`fmcard fmcard-${type} fmcard-${size} ${className}`} />;
}
